module.exports = __webpack_public_path__ + "img/建筑幕墙工程设计专项甲级.a1db1c49.png";